const KEY = "flyingTextEnabled";
const EVENT_NAME = "flying-text-toggle";

function getStorage(): Storage | undefined {
  try {
    const s = (globalThis as any)?.localStorage as Storage | undefined;
    return s;
  } catch {
    return undefined;
  }
}

export function readFlyingTextEnabled(opts?: { defaultValue?: boolean }): boolean {
  const defaultValue = opts?.defaultValue ?? true;
  const storage = getStorage();
  if (!storage) return defaultValue;

  try {
    const raw = storage.getItem(KEY);
    if (raw === null) return defaultValue;
    return raw === "true";
  } catch {
    return defaultValue;
  }
}

export function writeFlyingTextEnabled(enabled: boolean) {
  const storage = getStorage();
  try {
    storage?.setItem(KEY, String(enabled));
  } catch {
    // ignore storage errors
  }

  // Notify same-tab listeners (storage event won't fire in the same tab).
  try {
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function") {
      window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: enabled }));
    }
  } catch {
    // ignore event errors
  }
}

export function subscribeFlyingTextEnabled(onChange: (enabled: boolean) => void) {
  if (typeof window === "undefined") return () => {};

  const onToggleEvent = (event: Event) => {
    try {
      const enabled = Boolean((event as CustomEvent).detail);
      onChange(enabled);
    } catch {
      onChange(readFlyingTextEnabled());
    }
  };

  const onStorage = (e: StorageEvent) => {
    if (e.key !== KEY) return;
    onChange(readFlyingTextEnabled());
  };

  window.addEventListener(EVENT_NAME, onToggleEvent as EventListener);
  window.addEventListener("storage", onStorage);

  return () => {
    window.removeEventListener(EVENT_NAME, onToggleEvent as EventListener);
    window.removeEventListener("storage", onStorage);
  };
}


